/**
 * Our Process Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initOurProcess() {
        const blocks = document.querySelectorAll('.our-process');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] our-process block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOurProcess);
    } else {
        initOurProcess();
    }
})();